 /*jshint esversion: 6 */

 import Vue from 'vue'
 import Router from 'vue-router'
 import Reader from '@/components/Reader'
 import Home from '@/components/home'
 import HTML9780226160702_00_COVER from '@/components/html/9780226160702_00_cover'
 import HTML9780226160702_02_CPY from '@/components/html/9780226160702_02_cpy'
 import HTML9780226160702_01_TIT from '@/components/html/9780226160702_01_tit'
 import HTML9780226160702_03_DED from '@/components/html/9780226160702_03_ded'
 import HTML9780226160702_04_PRE from '@/components/html/9780226160702_04_pre'
 import HTML9780226160702_05_TOC from '@/components/html/9780226160702_05_toc'
 import HTML9780226160702_06_PLA from '@/components/html/9780226160702_06_pla'
 import HTML9780226160702_07_MAP from '@/components/html/9780226160702_07_map'
 import HTML9780226160702_08_TAB from '@/components/html/9780226160702_08_tab'
 import HTML9780226160702_09_INT from '@/components/html/9780226160702_09_int'
 import HTML9780226160702_10_PT1 from '@/components/html/9780226160702_10_pt1'
 import HTML9780226160702_11_CH1 from '@/components/html/9780226160702_11_ch1'
 import HTML9780226160702_12_MAP1 from '@/components/html/9780226160702_12_map1'
 import HTML9780226160702_13_CH2 from '@/components/html/9780226160702_13_ch2'
 import HTML9780226160702_14_CH3 from '@/components/html/9780226160702_14_ch3'
 import HTML9780226160702_15_CH4 from '@/components/html/9780226160702_15_ch4'
 import HTML9780226160702_16_CH5 from '@/components/html/9780226160702_16_ch5'
 import HTML9780226160702_17_CH6 from '@/components/html/9780226160702_17_ch6'
 import HTML9780226160702_18_PT2 from '@/components/html/9780226160702_18_pt2'
 import HTML9780226160702_19_CH7 from '@/components/html/9780226160702_19_ch7'
 import HTML9780226160702_20_CH8 from '@/components/html/9780226160702_20_ch8'
 import HTML9780226160702_21_CH9 from '@/components/html/9780226160702_21_ch9'
 import HTML9780226160702_22_CH10 from '@/components/html/9780226160702_22_ch10'
 import HTML9780226160702_23_CH11 from '@/components/html/9780226160702_23_ch11'
 import HTML9780226160702_25_CON from '@/components/html/9780226160702_25_con'
 import HTML9780226160702_24_NOT from '@/components/html/9780226160702_24_not'
 import HTML9780226160702_26_NOT1 from '@/components/html/9780226160702_26_not1'
 import HTML9780226160702_27_IND from '@/components/html/9780226160702_27_ind'
import Last from '@/components/last'

Vue.use(Router)

export default new Router({
	routes: [
	{
 			"path" : "/",
 			"name" : "home",
 			"component" : Home
 		},
 		{
 			"path" : "/html/9780226160702_05_toc",
 			"name" : "html/9780226160702_05_toc",
 			"component" : HTML9780226160702_05_TOC
 		},
 		{
 			"path" : "/html/9780226160702_06_pla",
 			"name" : "html/9780226160702_06_pla",
 			"component" : HTML9780226160702_06_PLA
 		},
 		{
 			"path" : "/html/9780226160702_07_map",
 			"name" : "html/9780226160702_07_map",
 			"component" : HTML9780226160702_07_MAP
 		},
 		{
 			"path" : "/html/9780226160702_08_tab",
 			"name" : "html/9780226160702_08_tab",
 			"component" : HTML9780226160702_08_TAB
 		},
 		{
 			"path" : "/html/9780226160702_09_int",
 			"name" : "html/9780226160702_09_int",
 			"component" : HTML9780226160702_09_INT
 		},
 		{
 			"path" : "/html/9780226160702_10_pt1",
 			"name" : "html/9780226160702_10_pt1",
 			"component" : HTML9780226160702_10_PT1
 		},
 		{
 			"path" : "/html/9780226160702_11_ch1",
 			"name" : "html/9780226160702_11_ch1",
 			"component" : HTML9780226160702_11_CH1
 		},
 		{
 			"path" : "/html/9780226160702_12_map1",
 			"name" : "html/9780226160702_12_map1",
 			"component" : HTML9780226160702_12_MAP1
 		},
 		{
 			"path" : "/html/9780226160702_13_ch2",
 			"name" : "html/9780226160702_13_ch2",
 			"component" : HTML9780226160702_13_CH2
 		},
		{
 			"path" : "/last",
 			"name" : "last",
 			"component" : Last
 		},
	]
})


// WEBPACK FOOTER //
// ./src/router/index.js